import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { demoService } from '../services/api';
import '../styles/Auth.css';

export default function DemoSignup() {
  const [username, setUsername] = useState('');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await demoService.signup(username, email, password);
      const { access_token, is_admin, user_id, role } = response.data;
      setAuth(access_token, user_id, username, is_admin, role);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Signup failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Noctis Ledger</h1>
        <p className="subtitle">Free 5-Day Trial</p>
        <p className="demo-disclaimer">
          🚧 Noctis Ledger is still under active development — features may change.
          Your trial account will be automatically disabled after 5 days.
          One free trial per email address.
        </p>
        <form onSubmit={handleSignup}>
          <input
            type="text"
            placeholder="Choose a username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Choose a password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <div className="error">{error}</div>}
          <button type="submit" disabled={loading}>
            {loading ? 'Creating trial...' : 'Start 5-Day Free Trial'}
          </button>
        </form>
        <p className="auth-footer-note">
          Already have an account? <a href="/login">Log in</a>
        </p>
      </div>
    </div>
  );
}
